<template>
  <div>
    <h3 class="title-func" id="introduction">
      <LabelFunMessage fcontId="0" msgkey="33" />
    </h3>

    <div class="how_step article">
      <div class="row">
        <div class="col-sm-8 col-md-8 col-lg-8 col-sm-push-4 col-md-push-4 col-lg-push-4">
          <p class="indent_caption">
            <LabelFunMessage fcontId="0" msgkey="94" />
          </p>
          <p>
            <LabelFunMessage fcontId="0" msgkey="95" />
          </p>
          <p>
            <a href="https://www.shihomasuda.com/" target="_blank" rel="noopener">
              <LabelFunMessage fcontId="0" msgkey="34" />
            </a>
            <br/>
            <a href="https://www.instagram.com/shihomasuda_giftwrapping/" target="_blank" rel="noopener">
              <LabelFunMessage fcontId="0" msgkey="52" />
            </a>
            <br/>
            <a href="https://www.youtube.com/user/ShihoMasuda" target="_blank" rel="noopener">
              YouTube
            </a>
          </p>
        </div>
        <!--/col-->

        <div class="col-sm-4 col-md-4 col-lg-4 col-sm-pull-8 col-md-pull-8 col-lg-pull-8">
          <img
            :src="app_root + '/assets/common/img/creator/masudashiho_360.jpg'"
            class="img-responsive center-block"
          />
        </div>
        <!--/col-->

        <div class="col-sm-12 col-md-12 col-lg-12">
          <h5><LabelFunMessage fcontId="0" msgkey="96" /></h5>
        </div>
      </div>
      <!--/row-->
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "CreatorProfileShihoMasuda",
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>